export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdEdtHalVyrParams';
export const NAME = 'HalerVyrov';

export const COLUMN_HALERVYROV_PRP = 'HALERVYROV_PRP';
